<template>
    <div v-if="stuData">
        <div class="box">
            <h3><i></i>得分率分布</h3>
            <div id="scoreChart"
                 style="width:15rem; height: 9.5rem;"></div>
        </div>
        <div class="con">
            <h3>未批改<span>{{stuData.is_not_correct_user.length}}</span>人</h3>
            <div class="uncorrect correctbox">
                <span>张笑笑</span>
                <span>张笑笑</span>
                <span>张笑笑</span>
                <span>张笑笑</span>
                <span>张笑笑</span>
                <span>张笑笑</span>
                <span>张笑笑</span>
                <span>张笑笑</span>
                <span>张笑笑</span>
                <span>张笑笑</span>
                <span>张笑笑</span>
                <span>张笑笑</span>
                <span>张笑笑</span>
                <span>张笑笑</span>
            </div>
        </div>
        <div class="con">
            <h3>已批改<span>{{stuData.is_correct_user.length}}</span>人</h3>
            <div class="corrected correctbox">
                <table>
                    <tbody>
                        <tr>
                            <th>姓名</th>
                            <th>成绩</th>
                            <th>提交时间</th>
                        </tr>
                        <tr>
                            <td>笑笑</td>
                            <td>85分</td>
                            <td class="c-999">07-21 10:26 <i class="icon_arrow_right"></i></td>
                        </tr>
                        <tr>
                            <td>笑笑</td>
                            <td>85分</td>
                            <td class="c-999">07-21 10:26 <i class="icon_arrow_right"></i></td>
                        </tr>
                        <tr>
                            <td>笑笑</td>
                            <td>85分</td>
                            <td class="c-999">07-21 10:26 <i class="icon_arrow_right"></i></td>
                        </tr>
                        <tr>
                            <td>笑笑</td>
                            <td>85分</td>
                            <td class="c-999">07-21 10:26 <i class="icon_arrow_right"></i></td>
                        </tr>
                        <tr>
                            <td>笑笑</td>
                            <td>85分</td>
                            <td class="c-999">07-21 10:26 <i class="icon_arrow_right"></i></td>
                        </tr>
                        <tr>
                            <td>笑笑</td>
                            <td>85分</td>
                            <td class="c-999">07-21 10:26 <i class="icon_arrow_right"></i></td>
                        </tr>
                        <tr>
                            <td>笑笑</td>
                            <td>85分</td>
                            <td class="c-999">07-21 10:26 <i class="icon_arrow_right"></i></td>
                        </tr>
                        <tr>
                            <td>笑笑</td>
                            <td>85分</td>
                            <td class="c-999">07-21 10:26 <i class="icon_arrow_right"></i></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
import * as echarts from 'echarts';
export default {
    props: ['stuData', 'sid', 'cid', 'unitId', 'gradeAverage'],
    data () {
        return {
            array: [],
        }
    },
    mounted () {
        setTimeout(() => {
            this.initChart();
            MathJax.Hub.Typeset(document.body)
        }, 500)
    },
    watch: {
        unitId () {
            //console.log(this.unitId)
            setTimeout(() => {
                this.initChart();
                MathJax.Hub.Typeset(document.body)
            }, 500)
        }
    },
    methods: {
        setIndex (score) {
            let num = score == 0 ? 0 : parseInt(score / 20);
            if (score == 100) {
                num = 4;
            }
            return num;
        },
        initChart () {
            // let array = [];
            let _this = this;
            this.stuData.score_group.forEach(e => {
                this.array.push(e.num);
            });
            let chartDom = document.getElementById('scoreChart');
            let myChart = echarts.init(chartDom);
            // let xNum = _this.setIndex(_this.stuData.score);
            let XArray = ['0%-20%', '20%-40%', '40%-60%', '60%-80%', '80%-100%'];
            // return false
            let option = {
                grid: {
                    top: '10%',
                    left: '1%',
                    right: '10%',
                    bottom: '4%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: XArray,
                    axisLabel: {
                        interval: 0,
                        textStyle: {
                            fontSize: '8'      //更改坐标轴文字大小
                        }
                    }
                },
                yAxis: {
                    type: 'value',
                    interval: 1,
                    axisLabel: {
                        formatter: '{value}人'
                    }
                },
                series: [
                    {
                        data: this.array,
                        type: 'line',
                        markLine: {
                            data: [
                                {
                                    symbol: 'none',
                                    xAxis: XArray[_this.setIndex(_this.stuData.unit_score_rate)],
                                    label: {
                                        formatter: function () { return '班级平均' }
                                    }
                                },
                                {
                                    symbol: 'none',
                                    xAxis: XArray[_this.setIndex(_this.gradeAverage)],
                                    label: {
                                        formatter: function () { return '年级平均' }
                                    }
                                }
                            ]
                        },
                        areaStyle: {
                            opacity: 0.6,
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                {
                                    offset: 0,
                                    color: '#85aefd'
                                },
                                {
                                    offset: 1,
                                    color: '#d8e5fe'
                                }
                            ])
                        }
                    }
                ]
            };
            option && myChart.setOption(option);
        },
        toDetail (stu) {
            localStorage.setItem('teaTaskUnitData', JSON.stringify(this.array))
            this.$router.push(`/chinese/inspect/stuDetail?sid=${this.sid}&cid=${this.cid}&userId=${stu.user_id}&unitId=${this.unitId}&name=${stu.username}&score=${stu.score}&rate=${this.stuData.unit_score_rate}`);
        }
    },

}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.box {
    width: 600px / $ppr;
    margin: 25px / $ppr auto 30px / $ppr;
    background: #fff;
    padding: 30px / $ppr 30px / $ppr 46px / $ppr;
    border-radius: 16px / $ppr;
    h3 {
        font-size: 30px / $ppr;
        margin-bottom: 24px / $ppr;
        line-height: 56px / $ppr;
        position: relative;
        padding-left: 48px / $ppr;
        font-weight: bold;
        i {
            position: absolute;
            left: 0;
            top: 50%;
            margin-top: -17px / $ppr;
            display: block;
            width: 32px / $ppr;
            height: 32px / $ppr;
            background: url("../img/icon04.png") 0 0 no-repeat;
            background-size: 100% 100%;
        }
    }
}
.con {
    width: 660px / $ppr;
    margin: 0 auto;
    h3 {
        color: #3c7cfb;
        font-size: 24px / $ppr;
        line-height: 74px / $ppr;
        height: 74px / $ppr;
        font-weight: bold;
        span {
            font-size: 28px / $ppr;
        }
    }
    .correctbox {
        width: 600px / $ppr;
        padding: 24px / $ppr 30px / $ppr;
        margin: 0 auto 35px / $ppr;
        border-radius: 16px / $ppr;
        background: #fff;
    }
    .uncorrect {
        span {
            width: 25%;
            display: inline-block;
            text-align: center;
            line-height: 80px / $ppr;
        }
    }
    .corrected {
        width: 100%;
        padding: 0;
        table {
            text-align: center;
            width: 100%;
            th {
                font-weight: bold;
            }
            th,
            td {
                width: 33.33333%;
                text-align: center;
                padding-top: 30px / $ppr;
                padding-bottom: 30px / $ppr;
            }
            tr {
                &:nth-child(2n) {
                    background: #fafafa;
                }
            }
        }
        .icon_arrow_right {
            display: inline-block;
            width: 12px / $ppr;
            height: 22px / $ppr;
            background: url(../img/icon_arrow_right.png) no-repeat center;
            background-size: cover;
            margin-left: 10px / $ppr;
        }
    }
}
.c-999 {
    color: #999;
}
</style>